<app-header [transparent]="transparent" />
<div class="awardrecog">
  <div class="text-center top_padding3 inline_padding2 bg_1">
    <ng-container *ngFor="let heading of head">
      <div class="awardrecog_top" *ngIf="heading.page === currentPage">
        <div class="inline_padding3">
          <span class="text_black_6_res">Awards and Recognition</span>
        </div>
        <div class="inline_padding3 p-top-16">
          <span class="text_style_1" [innerHtml]="heading.page_sub_heading"></span>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="awardrecog_body bottom_padding1 bg_2 inline_padding1 p-top-16">
    <span class="text_black_7">Awarded The Certificate</span>
    <div class="p-top-16">
      <article class="text_style_9 text_align-justify">
        On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and
        demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the
        pain and trouble that are bound to ensue; and equal blame belongs to those who fail in their duty
        through weakness of will, which is the same as saying through shrinking from toil and pain. These cases
        are perfectly simple and easy to distinguish.</article>
    </div>
    <div class="share-buttons" style="margin-top:10px;">
      <button (click)="copyLink()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fas fa-link" style="color: #000;"></i> <!-- Copy Link -->
      </button>
      <button (click)="shareViaEmail()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fas fa-envelope" style="color: #EA4335;"></i> <!-- Email -->
      </button>
      <button (click)="shareViaSMS()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fas fa-sms" style="color: #25D366;"></i> <!-- SMS -->
      </button>
      <button (click)="shareViaWhatsApp()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-whatsapp" style="color: #25D366;"></i> <!-- WhatsApp -->
      </button>
      <button (click)="shareViaMessenger()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-facebook-messenger" style="color: #0084FF;"></i> <!-- Messenger -->
      </button>
      <button (click)="shareViaViber()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-viber" style="color: #59267C;"></i> <!-- Viber -->
      </button>
      <button (click)="shareViaFacebook()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-facebook" style="color: #4267B2;"></i> <!-- Facebook -->
      </button>
      <button (click)="shareViaTwitter()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-twitter" style="color: #1DA1F2;"></i> <!-- Twitter -->
      </button>
      <button (click)="shareViaLinkedIn()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-linkedin" style="color: #0077B5;"></i> <!-- LinkedIn -->
      </button>
      <button (click)="shareViaPinterest()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-pinterest" style="color: #E60023;"></i> <!-- Pinterest -->
      </button>
      <button (click)="shareViaReddit()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-reddit" style="color: #FF4500;"></i> <!-- Reddit -->
      </button>
      <button (click)="shareViaTumblr()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-tumblr" style="color: #35465C;"></i> <!-- Tumblr -->
      </button>
      <button (click)="shareViaTelegram()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-telegram" style="color: #0088CC;"></i> <!-- Telegram -->
      </button>
      <button (click)="shareViaVK()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-vk" style="color: #4B7BE5;"></i> <!-- VK -->
      </button>
      <button (click)="shareViaMix()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-mix" style="color: #00A3E0;"></i> <!-- Mix -->
      </button>
      <button (click)="shareViaXing()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-xing" style="color: #006567;"></i> <!-- Xing -->
      </button>
      <button (click)="shareViaLine()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-line" style="color: #00B900;"></i> <!-- Line -->
      </button>

    </div>
    <div class="awardrecog_body_flex p-top-40">
      <!-- <ng-container *ngFor="let award of awards">
                <div class="awardrecog_body_flex_item p-bot-16">
                    <img class="awardrecog_body_flex_item_img" [src]="awardBaseUrl+award.award_image" alt="certificate"/>
                    <div class="awardrecog_body_flex_item_bottom p-top-32">
                        <span class="text_blue_8">
                            {{ award.awardee?.length > 60 ? (award.awardee.slice(0, 60) + '...') : award.awardee }}
                          </span>
                          
                        <div class="p-top-8">
                            <span class="text_black_4_res">{{award.date}} | {{award.award_title?.slice(0, 100)}}</span>
                        </div>
                          <div class="p-top-8 " *ngIf="award.web_link">
                            <div>
                                <span class="text_black_10">Weblink: </span>
                            </div>
                            <div>
                                <a [href]="award.web_link" class="text_blue_14" target="_blank">
                                    {{ award.web_link }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>             -->
      <ng-container *ngFor="let award of awards, let i = index">
        <div class="awardrecog_body_flex_item p-bot-16">
          <img class="awardrecog_body_flex_item_img" [src]="getAwardImageUrl(award)" alt="certificate" />

          <div class="awardrecog_body_flex_item_bottom p-top-32"
            *ngIf="award.awardee || award.date || award.award_title || award.web_link ">
            <span class="text_blue_8" *ngIf="award.awardee">
              {{ award.awardee?.length > 40 ? (award.awardee.slice(0, 40) + '...') : award.awardee }}
            </span>

            <div class="p-top-8" *ngIf="award.date || award.award_title">
              <span class="text_black_4_res">{{ award.date | date: 'dd-MM-yyyy' }} | {{ award.award_title?.slice(0, 55)
                + '...' }}</span>
            </div>

            <!-- <div class="p-top-8" *ngIf="award.web_link">
                      <span class="text_black_10">Weblink:</span>
                      <a [href]="award.web_link" class="text_blue_14 weblink" target="_blank">{{ award.web_link }}</a>
                    </div> -->
            <!-- <div class="p-top-8" *ngIf="readMoreState[i] && award.web_link">
                        <div class="weblink-container">
                          <span class="text_black_10">Weblink: </span>
                          <a [href]="award.web_link" class="text_blue_14 word-break" target="_blank">
                            {{ award.web_link }}
                          </a>
                        </div>
                      </div>
                      
                      <div (click)="toggleReadMore(i)" class="text_blue_14 cursor-pointer">
                          {{ readMoreState[i] ? 'Read Less' : 'Read More' }}
                      </div> -->
            <div class="p-top-12" style="display: flex; justify-content: flex-start;">
              <button type="button" class="rounded-pill text_white_1 button_blue_7"
                (click)="openLink(getAwardWebLink(award))"
                style="width: 150px; padding: 12px 24px; display: flex; justify-content: space-between; align-items: center; border: 0;">
                <span class="button_blue_1_text" style="font-size: 16px;">Weblink</span>
                <img class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png"
                  style="height: 14px; max-width: none; object-fit: contain; margin-left: 10px;" />
              </button>
            </div>

          </div>
        </div>
      </ng-container>



      <!-- <ng-container *ngFor="let award of awards">
                <div class="awardrecog_body_flex_item p-bot-16">
                    <img class="awardrecog_body_flex_item_img" [src]="awardBaseUrl + award.award_image"
                        alt="certificate" />
                    <div class="awardrecog_body_flex_item_bottom p-top-32">
                        <span class="text_blue_8">
                            {{ award.awardee }}
                        </span>
                        <div class="p-top-8 text-wrap">
                            <span class="text_black_4_res">{{ award.date }} | {{ award.award_title }}</span>
                        </div>
                    </div>
                </div>
            </ng-container> -->

    </div>
    <!-- <div class="p-top-60">
            <span class="text_style_9 text_align-justify">On the other hand, we denounce with righteous indignation and dislike men who are
                so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they
                cannot foresee the pain and trouble that are bound to ensue; and equal blame belongs to those who fail
                in their duty through weakness of will, which is the same as saying through shrinking from toil and
                pain. These cases are perfectly simple and easy to distinguish.</span>
        </div> -->
  </div>
</div>
<app-footer />